var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { ethers } from 'ethers';
import { t } from 'i18next';
import { getContract } from '@sovryn/contracts';
import { TransactionType } from '../../../3_organisms/TransactionStepDialog/TransactionStepDialog.types';
import { useTransactionContext } from '../../../../contexts/TransactionContext';
import { useAccount } from '../../../../hooks/useAccount';
import { translations } from '../../../../locales/i18n';
import { getRskChainId } from '../../../../utils/chain';
export const useClaimCollateralSurplus = (onComplete) => {
    const { signer } = useAccount();
    const { setTransactions, setIsOpen, setTitle } = useTransactionContext();
    return useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { address, abi: massetManagerAbi } = yield getContract('borrowerOperations', 'zero', getRskChainId());
            const borrowerOperations = new ethers.Contract(address, massetManagerAbi, signer);
            setTransactions([
                {
                    title: t(translations.zeroPage.tx.claimSurplus),
                    request: {
                        type: TransactionType.signTransaction,
                        contract: borrowerOperations,
                        fnName: 'claimCollateral',
                        args: [],
                    },
                    onComplete,
                },
            ]);
            setTitle(t(translations.zeroPage.tx.claimSurplusTitle));
            setIsOpen(true);
        }
        catch (error) {
            console.log('error:', error);
        }
    }), [onComplete, setIsOpen, setTitle, setTransactions, signer]);
};
